import React from 'react'
import {useSelector} from 'react-redux'
import _ from 'lodash'
import { Fragment} from 'react'
import classNames from 'classnames'

let Rfid = function(props){

  const rfid = useSelector(state => state.rfid)
  const input_width = useSelector(state => state.input_width) ? useSelector(state => state.input_width) : "8"
  const label_width = useSelector(state => state.label_width) ? useSelector(state => state.label_width) : "3"

  return (
    <Fragment>
      {rfid.enabled &&
        <div className="form-group row" key={"col" +  "tag_owner.rfid"}>
          <label htmlFor="rfid.code" className={"col-md-" + label_width + " r-label col-form-label"} dangerouslySetInnerHTML={{ __html: rfidText ? rfidText : "NFC Wristband"}}></label>
          <div className={"col-md-" + input_width + ""}>
            <div className="form-check">
              <input name="rfid.code" id="rfid.code" ref={props.register}  type="text" className={classNames("form-check-input", { "is-invalid": props.errors && props.errors.tag_owner && props.errors.tag_owner.rfid })} />
              {props.errors && props.errors.tag_owner && props.errors.tag_owner.rfid && <div className="invalid-feedback" dangerouslySetInnerHTML={{ __html: props.errors.tag_owner.rfid.message}}></div>}
            </div>
          </div>
        </div>
      }
    </Fragment>
  )
}
export default Rfid;